import { __t } from '../../../i18n';
import { IconSeasons } from '../../../icons';
import { PlayerControlButton } from '../styles';

/**
 * Opens the shorts info panel. Rendered only where that panel isn't already on screen — the
 * host passes a handler on mobile and nothing on desktop.
 */
const ControlBarInfo = ({ onClick }: { onClick: () => void }) => (
  <PlayerControlButton
    size="semiLarge"
    icon={<IconSeasons />}
    onClick={onClick}
    title={__t('shorts.info')}
    mr={0.5}
  />
);

export default ControlBarInfo;
